import { DECIMAL_FORMAT, INTEGER_FORMAT } from 'components/common/formatters/numbers/constants';

/** @typedef {{MM: string, IN_1_32: string}} SmallDistanceUnit */
export const SmallDistanceUnit = {
  MM: 'MM',
  IN_1_32: 'IN_1_32',
};

/** @typedef {{KM: string, MI: string}} LargeDistanceUnit */
export const LargeDistanceUnit = {
  KM: 'KM',
  MI: 'MI',
};

/** @typedef {{KM: string, MI: string}} SmallDistanceUnitName */
export const SmallDistanceUnitName = {
  [SmallDistanceUnit.MM]: 'millimeter',
};

/** @typedef {{KM: string, MI: string}} LargeDistanceUnitName */
export const LargeDistanceUnitName = {
  [LargeDistanceUnit.KM]: 'kilometer',
  [LargeDistanceUnit.MI]: 'mile',
};

/** @typedef {SmallDistanceUnit | LargeDistanceUnit} DistanceUnit */

/** @type {{ smallDistanceUnit: SmallDistanceUnit, largeDistanceUnit: LargeDistanceUnit }} */
export const DEFAULT_UNITS = {
  smallDistanceUnit: SmallDistanceUnit.MM,
  largeDistanceUnit: LargeDistanceUnit.KM
};
const BASE_UNIT_FORMAT = { style: 'unit', unitDisplay: 'short' };

export const getUnitForValue = (value, unit, intl) => {
  const isSmallUnit = Boolean(SmallDistanceUnitName[unit]);
  const unitName = SmallDistanceUnitName[unit] ?? LargeDistanceUnitName[unit];
  const numberFormat = isSmallUnit ? DECIMAL_FORMAT : INTEGER_FORMAT;

  const formattedValue = intl.formatNumber(value, unitName
    ? { ...BASE_UNIT_FORMAT, unit: unitName, ...numberFormat }
    : {});

  return !unitName
    ? `${formattedValue} ${intl.formatMessage({ id: `web.units.${unit.toLowerCase()}`, defaultMessage: unit.toLowerCase() })}`
    : formattedValue;
};
